// extracted by css-extract-rspack-plugin
export default {"serviceBasicInfoBox":"serviceBasicInfoBox-bWTVrJ","serviorBox":"serviorBox-PQJC6i"};